//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Container from "./Container";
import Btn from "../Button/Btn";
import Images from "../../config/images";
import {formatDimension} from "../../helpers/format_helpers";
import MenuBtn from "../Button/MenuBtn";
import CdnImage from "../Image/CdnImage";
import Toggleable from "../../mixins/Toggleable";

export default {

    name: 'AppHeader',

    components: {
        MenuBtn,
        Container,
        Btn,
        CdnImage,
        Icon: () => import('../Icon/Icon'),
    },

    mixins: [Toggleable],

    props: {

        // The logo source
        logo: {
            type: String | Object,
            default: Images.logo.path
        },

        // The logo source for mobile devices
        mobileLogo: {
            type: String | Object,
            default: Images.favicon.path
        },

        // The aspect ratio of the logo image
        logoRatio: {
            type: Number,
            default: Images.logo.ratio
        },

        // The height of the logo image
        logoHeight: {
            type: Number,
            default: 26
        },

        // The aspect ratio of the mobile logo image
        mobileLogoRatio: {
            type: Number,
            default: Images.favicon.ratio
        },

        // The width of the logo area
        logoWidth: {
            type: Number,
            default: null
        },

        // The navigation items to show
        items: {
            type: Array,
            default: null
        },

        // The navigation items to show on the mobile layout
        mobileItems: {
            type: Array,
            default: null
        },

        // Whether the navbar is fixed to the top
        fixed: {
            type: Boolean,
            default: false
        },

        // Whether the navbar shall receive a bottom border
        border: {
            type: Boolean,
            default: false
        },

        // Whether the navbar container shall be full width
        fluid: {
            type: Boolean,
            default: false
        },

        // Whether no shadow shall be added
        flat: {
            type: Boolean,
            default: false
        },

        // Whether a clickable menu icon shall be displayed on mobile devices
        mobileMenu: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        logoWidthStyle() {
            return this.logoWidth ? formatDimension(this.logoWidth - 16) : null
        },

        showDesktopStyle() {
            return this.$device.isDesktop;
        }
    }

}
